import React, { memo } from "react";
import classes from "./EventHeader.scss";
import { IconButton } from "@toddle-edu/ds-web";
import { CloseOutlined, VideoFilled } from "@toddle-edu/ds-icons";
import classNames from "classnames";
import I18nHOC from "UIComponents/I18nHOC";
import ActionButtons from "./components/ActionButtons";
import { VIDEO_MEETING } from "ClassRoom/modules/ClassRoomModule";

const styles = {
  iconButtonCustomStyles: { height: "fit-content", padding: "8px" },
};

const EventHeader = props => {
  const {
    userType,
    onClickEdit,
    onClickDelete,
    onCloseEventModal,
    hideEditButton,
    isNotUserCourse,
    headerTitle,
    backgroundColor,
    itemType,
    isViewOnlyTag,
    t,
    isCurrentAcademicYear,
    isGradingPeriodUnlocked = true,
    testId,
    canManageAssignment = true,
    isAssessmentLocked,
    isVideoMeeting,
    canUserEditThisMeeting,
    isVideoMeetingRevampEnabled,
    isMeetingDetailsLoading,
  } = props;

  const eventTypeTextClasses = classNames(
    "text-label-l",
    classes.eventTypeText
  );

  const onClickClose = () => {
    onCloseEventModal({ isCloseClicked: true });
  };

  return (
    <div className={classes.header}>
      <div className={classes.eventType}>
        {isVideoMeeting && isVideoMeetingRevampEnabled ? (
          <VideoFilled style={{ color: VIDEO_MEETING.newColor }} />
        ) : (
          <div
            className={classes.eventTypeBadge}
            style={{ backgroundColor }}
          ></div>
        )}
        <div className={eventTypeTextClasses} dir="auto">
          {t(headerTitle)}
        </div>
      </div>
      <div className={classes.headerControls}>
        <ActionButtons
          onClickEdit={onClickEdit}
          onClickDelete={onClickDelete}
          hideEditButton={hideEditButton}
          isViewOnlyTag={isViewOnlyTag}
          isGradingPeriodUnlocked={isGradingPeriodUnlocked}
          isAssessmentLocked={isAssessmentLocked}
          canManageAssignment={canManageAssignment}
          userType={userType}
          isNotUserCourse={isNotUserCourse}
          isCurrentAcademicYear={isCurrentAcademicYear}
          t={t}
          testId={testId}
          isVideoMeeting={isVideoMeeting}
          canUserEditThisMeeting={canUserEditThisMeeting}
          isMeetingDetailsLoading={isMeetingDetailsLoading}
        />
        <IconButton
          icon={<CloseOutlined variant={"subtle"} />}
          style={styles.iconButtonCustomStyles}
          onClick={onClickClose}
          variant={"neutral"}
          type={"plain"}
          size={"medium"}
          isCompact={true}
          testId={`${testId}-close`}
          dsVersion={"2.0"}
        />
      </div>
    </div>
  );
};

export default I18nHOC({ resource: ["common", "classRoom", "project"] })(
  memo(EventHeader)
);
